<app-pop-up
	[id]="popUpId"
	[options]="{}"
>
	<div class="popup popup-biometrics-registration-offer-statement">
		<app-loader
			#loaderStep1
			[context]="'element'"
			[isActive]="false"
		></app-loader>
		<button
			class="button-reset close"
			type="button"
			(click)="close()"
		></button>

		<div class="popup__content popup-biometrics-registration-offer-statement__content">
			<section>
				<h3 class="popup__header">Предложение и Заявление</h3>
				<div class="popup__body popup-biometrics-registration-offer-statement__body">
					<div
						class="popup__body popup-biometrics-registration-offer-statement__body-pdf popup-biometrics-registration-offer-statement__body-pdf--with-background"
					>
						<h4
							class="popup-biometrics-registration-offer-statement__body-title popup-biometrics-registration-offer-statement__body-title--center"
						>
							Заявление о&nbsp;заключении Договора о&nbsp;карте Банк в&nbsp;кармане
							Digital и&nbsp;Договора дистанционного обслуживания
						</h4>

						<section
							class="popup-biometrics-registration-offer-statement__body-content"
						>
							<app-layout-item-renderer
								[layoutElement]="pdfIframeControlComponentBox"
							></app-layout-item-renderer>
						</section>
					</div>

					<section class="popup-biometrics-registration-offer-statement__body-content">
						<app-layout-item-renderer
							[layoutElement]="registrationProductConfirmationCodeComponentBox"
						></app-layout-item-renderer>
					</section>

					<app-error-presenter [errors]="errors"></app-error-presenter>
				</div>
				<div class="popup__footer popup-biometrics-registration-offer-statement__footer">
					<button
						class="button"
						type="button"
						(click)="next1()"
						[disabled]="!((newForm.statusChanges | async) && newForm.valid)"
					>
						Подтвердить
					</button>
				</div>
			</section>
		</div>
	</div>
</app-pop-up>
